'use strict'

import '@babel/polyfill'


import Intro from './lib/Intro'
import Rellax from './lib/Rellax'
import ScrollTrigger from './lib/ScrollTrigger'
import LinkHoverAnimation from './lib/LinkHoverAnimation'
import Slider from './lib/Slider'

document.addEventListener('DOMContentLoaded', ()=>{
    new LinkHoverAnimation
    new Slider
})


window.addEventListener('load', ()=>{
    new Intro
    new Rellax
    new ScrollTrigger
})